// extracted by mini-css-extract-plugin
module.exports = {"tabGroup":"_1ow031_tJkbrQIasDY2Bpm"};